import React, { useContext, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AuthContext } from '../App';

export const VerifyEmailBanner = () => {
  const { user } = useContext(AuthContext);
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified !== false || user.role === 'superadmin') return null;
  const resend = async () => { try { await axios.post('/auth/resend-verification'); setSent(true); toast.success('Verification email sent'); } catch (e) { toast.error(e?.response?.data?.detail || 'Could not send'); } };
  return (
    <div data-testid="verify-email-banner" style={{ background: '#312E81', color: '#E0E7FF', fontSize: 13, padding: '8px 16px', display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
      Please verify your email address ({user.email}) — check your inbox.
      <button data-testid="verify-email-resend-btn" onClick={resend} disabled={sent} style={{ background: 'transparent', border: '1px solid #818CF8', color: '#fff', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>{sent ? 'Sent' : 'Resend'}</button>
    </div>
  );
};
